export const faq_page_events = {
  faqs_back_button_click: {
    category: "Navigates back from FAQ page",
    action: "User clicks on back button ",
    label: "faqs-back-button-click",
  },
  privacy_policy_logo_click: {
    category: "Legal",
    action: "User clicks logo on privacy policy page",
    label: "privacy-policy-logo-click",
  },
  privacy_policy_back_click: {
    category: "Legal",
    action: "User clicks back on privacy policy page",
    label: "privacy-policy-back-click",
  },
  tos_back_click: {
    category: "Legal",
    action: "User clicks back on terms of service page",
    label: "terms-of-service-back-click",
  },
  tos_logo_click: {
    category: "Legal",
    action: "User clicks logo on tos page",
    label: "terms-of-service-logo-click",
  },

  faqs_back_downward_accordion_click: {
    category: "Which opens the selected FAQ and answer",
    action: "User clicks on downward accordion",
    label: "faqs-back-downward-accordion-click",
  },
  faqs_back_upward_accordion_click: {
    category: "Which closes the selected FAQ and answer",
    action: "User clicks on upward accordion",
    label: "faqs-back-upward-accordion-click",
  },
};
